import * as React from "react";
import { startCase, get } from 'lodash';
import StatusBanner from '../common/StatusBanner';
import * as Tools from "../../helpers/Tools";
import { translateText } from '../../helpers/data';
import { formatPhoneNumber, firstNameFirst, getFirstName } from "../../helpers/formatting";
import { logUI } from '../../api/andyliticsApi';
import { connect } from "react-redux";
import { withRouter } from 'react-router-dom';
import * as types from "../../constants/actionTypes";


const DATE_FORMAT = Tools.getDateFormats();

class OpenScheduleConfirmationSuccess extends React.Component {
    constructor(props) {
        super(props);
        this.formatTime = this.formatTime.bind(this);
    }

    componentDidMount() {
        const { scheduleCampaignReferrer, eCheckInStatusSuccess, schedule, scheduleAppointmentSuccess, scheduleAppointmentFailed, providerDetails, visit, departments, careGapsSessionId, updateCareGapFlowFormInputs, postCareGapFlowData, visitTypelabel, careGapFlowFormInputs } = this.props;
        const scheduleCampaignActivity = scheduleCampaignReferrer ? { scheduleCampaignReferrer: scheduleCampaignReferrer } : {};
        logUI("MBHWeb.UI.OpenScheduleConfirmationSuccess.ComponentDidMount", new Date(), Tools.getURLPath(), scheduleCampaignActivity);

        if (!eCheckInStatusSuccess && schedule) {
            const csnId = _.filter(
                schedule.contactIDs, function (o) {
                    return o.type == "CSN";
                }
            )[0].id;
            if (csnId)
                this.props.getEncryptedCSN(csnId);
        }
        const defaultPhone =
            providerDetails && providerDetails?.consumerCallCenterNumber
                ? providerDetails?.consumerCallCenterNumber
                : visit?.department
                    ? visit?.department?.phone
                    : "";
        const address = visit?.department?.address;
        const location = address && (address.street1 || address.city) ? (address.street1 ? address.street1 + ', ' : '') + address.city + ', ' + address.state + ' ' + address.zip : "-";
        const { label, label2 } = departments[0] || {};
        let user = {
            dateCompleted: new Date().toLocaleDateString(),
            FacilityAddress: location,
            pNumber: defaultPhone,
            name: label
        }
        scheduleAppointmentSuccess === true && scheduleAppointmentFailed !== true && careGapsSessionId != '' && updateCareGapFlowFormInputs(user, visitTypelabel)
    }
    componentDidUpdate(prevProps, prevState) {
        const { scheduleAppointmentSuccess, scheduleAppointmentFailed, careGapsSessionId, postCareGapFlowData, visitTypelabel, careGapFlowFormInputs } = this.props;

        if (prevProps.careGapFlowFormInputs !== careGapFlowFormInputs) {
            if (scheduleAppointmentSuccess === true && scheduleAppointmentFailed !== true && careGapsSessionId != '') {
                logUI("MBHWeb.UI.OpenScheduleConfirmationSuccess.CareGaps.InBasketAPI.Sumbit", new Date(), Tools.getURLPath(), { careGapFlowFormInputs, careGapProcedureType: visitTypelabel });
                postCareGapFlowData(careGapFlowFormInputs, visitTypelabel)
            }
        }
    }
    componentWillUnmount() {
        this.props.clearFlowData();
    }
    date2str(x) {
        var dt = Tools.toJSDate(`${x}T00:00:00`, DATE_FORMAT);
        const { t, translate } = this.props;
        try {
            const dayName = dt.getDate();
            let monthName = dt.getMonth() + 1;
            if (monthName < 10)
                monthName = "0" + monthName;

            return `${translateText(t && translate, Tools.getMonthName(monthName.toString()), t)} ${dayName}`;
        }
        catch { }
    }

    formatTime(s) {
        let parts = s && s.split(":");
        let ret = s;

        if (parts && parts.length >= 2) {
            let h = parseInt(parts[0]);
            let m = parseInt(parts[1]);
            let s = parseInt(parts[2]);

            let ispm = h >= 12;
            h = h > 12 ? h - 12 : h;

            ret = `${h.toString()}:${m.toString().padStart(2, '0')} ${ispm ? "PM" : "AM"}`;
        }

        return ret;
    }

    editPatientInfo = (e, tryAgain) => {
        if (e) { e.preventDefault(); }

        if (tryAgain) {
            this.props.tryAgain(1);
        }
    }

    editAppt = (e, tryAgain) => {
        // Needs to go back to Appointment Info step
        if (e) { e.preventDefault(); }

        //this.props.resetWizard();

        if (tryAgain) {
            this.props.sendBack(false);
            this.props.tryAgain(0);
        }
    }

    eCheckInClick = () => {
        const { EncryptedCSN } = this.props;
        let EcheckInRoute = "/appointments";
        if (EncryptedCSN) {
            EcheckInRoute = EncryptedCSN ? { pathname: "/EcheckIn", state: { csnId: EncryptedCSN.CSNHash } } : { pathname: "/appointments" };
        }
        this.props.history.push(EcheckInRoute);
    }

    getTipsBannerMsg = (showBeginEcheckInBanner) => {
        const { currentUser, primaryUser, hasMyChart, scheduleAppointmentForProxy, translate, t } = this.props;
        const defaultWaitDays = 'a few';
        let tipsMsg = "";

        if (!currentUser || !hasMyChart) {
            tipsMsg = (<span><strong>{translateText(t && translate, "Please Note:", t)}</strong> {translateText(t && translate, "Your medical records will be available in your account once the care team links them to your account.", t)}</span>);
        } else if (hasMyChart) {
            if (!showBeginEcheckInBanner) {
                if (scheduleAppointmentForProxy) {
                    if (currentUser.eid === primaryUser.eid) {
                        tipsMsg = `Save some time before your visit! eCheck-In will be available on your dashboard ${defaultWaitDays} days prior to your visit.`;
                        tipsMsg = translateText(t && translate, tipsMsg, t);
                    }
                    else {
                        tipsMsg = `Save some time before your visit! eCheck-In will be available on {0}'s dashboard ${defaultWaitDays} days prior to their visit.`;
                        tipsMsg = translateText(t && translate, tipsMsg, t);
                        tipsMsg = tipsMsg.replace('{0}', getFirstName(currentUser.displayName));
                    }
                } else {
                    tipsMsg = `Save some time before your visit! eCheck-In will be available on your dashboard ${defaultWaitDays} days prior to your visit.`;
                    tipsMsg = translateText(t && translate, tipsMsg, t);
                }
            }
        }

        return tipsMsg;
    }

    render() {
        const { isMobile, isTablet, visit, providerDetails, serverData, arrivalTimeSchedule, enableFluVaccineSchedulingWorkflow, translate, visitTypelabel, primaryUser, currentUser,
            nonMyChartPatientDetails, scheduleAppointmentForProxy, schedule, hasMyChart, enableEcheckinMandatoryUpdates, isMammography, t
        } = this.props;
        const { label, label2 } = this.props.departments[0] || {};
        const visitDirections = visit && visit.department.address ? 'https://www.google.com/maps/place/' + visit.department.address.street1 + ', ' + visit.department.address.city + ', ' + visit.department.address.state + ' ' + visit.department.address.zip : '#';
        const visitDirectionsTarget = visit && visit.department.address ? '_blank' : '_self';
        const providerPhone = providerDetails && providerDetails.consumerCallCenterNumber ? providerDetails.consumerCallCenterNumber : (visit.department.phone ? visit.department.phone : "");
        const timezone = serverData && serverData.showTimeZoneMessage && !Tools.isCentralTimeZone() ? Tools.getCentralDateWithFormat(new Date(), "z") : "";
        let patientName = (visit.patient && visit.patient.name) ? visit.patient.name : (primaryUser && primaryUser.displayName ? primaryUser.displayName : "");
        patientName = scheduleAppointmentForProxy ? currentUser ? primaryUser.eid === currentUser.eid ? firstNameFirst(primaryUser.displayName) : firstNameFirst(currentUser.displayName) : patientName : patientName;
        const { eCheckInDays } = serverData || '';

        const visitDateTime = schedule && schedule.date && schedule.time ? new Date(`${schedule.date} ${schedule.time}`) : "";
        const numberOfDaysDiff = Tools.differenceInDays(visitDateTime);
        const showBeginEcheckInBanner = !this.props.scheduleAppointmentFailed && hasMyChart && numberOfDaysDiff <= parseInt(eCheckInDays) && enableEcheckinMandatoryUpdates;
        const tipsBannerMsg = this.getTipsBannerMsg(showBeginEcheckInBanner);

        return (
            <div className="schedule-confirmation-container">
                <div className="row">
                    {(this.props.scheduleAppointmentSuccess === true && this.props.scheduleAppointmentFailed !== true) &&
                        <div className="col-12">
                            <StatusBanner
                                bannerMsg={translateText(t && translate, "Thanks, you’re all set! We look forward to seeing you.", t)}
                                subBannerMsg={translateText(t && translate, "You’ll receive email confirmation for your appointment.", t)}
                            />
                        </div>
                    }

                    {this.props.scheduleAppointmentFailed === true
                        ? <div className="col-12">
                            <StatusBanner
                                bannerMsg={translateText(t && translate, "We were unable to schedule your appointment.", t)}
                                failedStatus
                            >
                                {this.props.createPatientFailed
                                    ? <span>
                                        {translateText(t && translate, "Please", t) + ' '}
                                        <a href="#" onClick={e => this.editPatientInfo(e, true)}>{translateText(t && translate, "try again", t)}</a>{' '}
                                        {translateText(t && translate, "and confirm your information is correct", t) + ' '}
                                        {providerPhone && <span>
                                            {translateText(t && translate, "or", t) + ' ' + translateText(t && translate, "call", t) + ' '}
                                            <a href={"tel:" + providerPhone} className="phone-link">{providerPhone}</a> {translateText(t && translate, "to schedule", t)}
                                        </span>}.
                                    </span>
                                    :
                                    <span>
                                        {translateText(t && translate, "Please", t) + ' ' + providerPhone + ' '} &&
                                        <span>
                                            {translateText(t && translate, "call", t) + ' '}
                                            <a href={"tel:" + providerPhone} className="phone-link">{providerPhone}</a>
                                            {' ' + translateText(t && translate, "to schedule or", t) + ' '}
                                        </span>
                                        <a href="#" onClick={e => this.editAppt(e, true)}>{translateText(t && translate, "try again", t)}</a>.
                                    </span>
                                }
                            </StatusBanner>
                        </div>
                        : <div className='col-12 confirm-container maxWidth-content'>
                            {showBeginEcheckInBanner &&
                                <div className="col-12 echeck-in-container">
                                    <span>{translateText(t && translate, "eCheck-in is required before your visit.", t)}</span>
                                    <button className="btn btn-primary" onClick={this.eCheckInClick}>{translateText(t && translate, "BEGIN ECHECK-IN", t)}</button>
                                </div>
                            }
                            <div className="row confirm-appt-details-container">
                                <div className={`confirm-doctor-addl-details confirm-doct-success ${enableFluVaccineSchedulingWorkflow ? 'col-12 col-lg-12 col-xl-12' : 'col-12 col-lg-6 col-xl-5'}`}>
                                    <div className={(isTablet && enableFluVaccineSchedulingWorkflow) ? "" : "row"}>
                                        <div className={(isTablet && enableFluVaccineSchedulingWorkflow) ? 'col-12 col-md-7 flu-location' : (isMobile && enableFluVaccineSchedulingWorkflow) ? 'col-12 col-md-4 flu-location' : enableFluVaccineSchedulingWorkflow ? 'col-4 col-md-4' : 'col-12 col-md-8 confirm-visit-info-container'}>
                                            <div className="item-details">
                                                <div className="row">
                                                    <div className="col-12 item-name">
                                                        {(isMammography || enableFluVaccineSchedulingWorkflow) ? <span>{translateText(t && translate, visitTypelabel.replace('d', 'D'), t)}</span>
                                                            : <span>{startCase(get(schedule, 'visitTypes[0].name', '').toLowerCase())}</span>}
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-12 item-location">
                                                        <div className="details-icon-prepend">
                                                            <div className="icon-col">
                                                                <span className="icon-address" />
                                                            </div>
                                                            <div className="details-col">
                                                                <span className="address-label">{`${label || ''}`}</span>
                                                                {visit && visit.department.address && (visit.department.address.street1 || visit.department.address.city)
                                                                    ? <a className="directions-link" href={visitDirections} target={visitDirectionsTarget}>
                                                                        <div>
                                                                            {visit.department.address.street1 || visit.department.address.street2 &&
                                                                                <div>{visit.department.address.street1}{visit.department.address.street2 && <span>, {visit.department.address.street2},</span>} </div>
                                                                            }
                                                                            <div>{visit.department.address.city}, {visit.department.address.state} {visit.department.address.zip} </div>
                                                                        </div>
                                                                    </a>
                                                                    : <div className="no-data-dash">
                                                                        <div />
                                                                    </div>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-12 item-phone">
                                                        <div className="details-icon-prepend">
                                                            <div className="icon-col">
                                                                <span className="icon-phone" />
                                                            </div>
                                                            <div className="details-col">
                                                                {providerPhone
                                                                    ? <a className="phone-link" href={"tel:" + providerPhone}>
                                                                        <div>{providerPhone.replaceAll('-', '.')}</div>
                                                                    </a>
                                                                    : <div className="no-data-dash">
                                                                        <div />
                                                                    </div>}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {!enableFluVaccineSchedulingWorkflow && <div className="row">
                                                <div className="col-12 confirm-dr-details">
                                                    <div className="appt-schedule-for">
                                                        <div className="appt-heading appt-heading-success"><span>{translateText(t && translate, "Appointment Scheduled For", t) + ' '}</span></div>
                                                        <div><span className="visit-time">{patientName}</span></div>
                                                        <div>{(nonMyChartPatientDetails && nonMyChartPatientDetails.phoneNumbers && nonMyChartPatientDetails.phoneNumbers[0]) &&
                                                            <div className="patient-phone">{formatPhoneNumber(nonMyChartPatientDetails.phoneNumbers[0].number)}</div>}</div>
                                                    </div>
                                                </div>
                                            </div>}
                                        </div>
                                        {enableFluVaccineSchedulingWorkflow && <div className={`col-12 col-md-4 confirm-dr-details flu-schedule-for ${isMobile && 'flu-schedule-mobile'} ${(isTablet && enableFluVaccineSchedulingWorkflow) ? ` col-md-12` : ``}`}>
                                            <div className="appt-schedule-for">
                                                <div className="appt-heading appt-heading-success"><span>{translateText(t && translate, "Appointment Scheduled For", t) + ' '}</span></div>
                                                <div><span className="visit-time">{patientName}</span></div>
                                                <div>{(nonMyChartPatientDetails && nonMyChartPatientDetails.phoneNumbers && nonMyChartPatientDetails.phoneNumbers[0]) &&
                                                    <div className="patient-phone">{formatPhoneNumber(nonMyChartPatientDetails.phoneNumbers[0].number)}</div>}</div>
                                            </div>
                                        </div>}
                                        <div className={`col-12 col-md-4 text-end visit-date-container ${enableFluVaccineSchedulingWorkflow && 'flu-vaccine-date-container'} ${isMobile && 'flu-vaccine-date-container-mobile'} ${(isTablet && enableFluVaccineSchedulingWorkflow) ? ' position-absolute' : ''}`}>
                                            <div>
                                                <div className="visit-date">{this.date2str(visit.date)}</div>
                                                <div className="visit-time"><span>{this.formatTime(visit.time)} {timezone}</span></div>
                                            </div>
                                        </div>
                                    </div>
                                    {!enableFluVaccineSchedulingWorkflow && <div className="confirm-seperator" />}
                                </div>
                                {!enableFluVaccineSchedulingWorkflow && <div className="col-12 col-lg-6 col-xl-7 confirm-instructions">
                                    <p className="instructions-heading">{translateText(t && translate, "Be Ready For Your Appointment", t)}</p>
                                    <p className="instructions-list">{translateText(t && translate, "Please bring any non-BSWH images and reports for comparison.", t)}</p>
                                    <p className="instructions-list">{translateText(t && translate, "Arrive at least {0} minutes before your appointment time.", t).replace('{0}', '15')}</p>
                                    <p className="instructions-list">{translateText(t && translate, "Bring your photo ID and insurance card(s) to your appointment.", t)}</p>
                                    <p className="instructions-list">{translateText(t && translate, "Wear a two piece outfit (e.g. A blouse and pants).", t)}</p>
                                    <p className="instructions-list">{translateText(t && translate, "Please refrain from wearing deodorant as it can cause issues with the results of the screening mammogram.", t)}</p>
                                    <p className="instructions-list">{translateText(t && translate, "If you experience any breast related symptoms prior to your appointment, please call our office prior to your arrival.", t)}</p>
                                    <p className="instructions-list">{translateText(t && translate, "Please do not bring children with you, as staff is unable to care for your child during your procedure.", t)}</p>
                                </div>}
                            </div>

                            {tipsBannerMsg && !enableFluVaccineSchedulingWorkflow &&
                                <div className="row">
                                    <div className="col-12">
                                        <div className="confirmation-status-container status-success">
                                            <div className="row align-items-center">
                                                <div className="col-12">
                                                    {tipsBannerMsg}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    }
                </div>
                {window.serverData.data.enableQualtricsSurveyOpenScheduling && !enableFluVaccineSchedulingWorkflow && <div data-component="OpenScheduleConformationSuccess" className="row  qtxSurvey"><div className="col-12 maxWidth-content"><div id={this.props.scheduleVisitType === "Video Visit" ? "bsw_qtx_video_schedule" : "bsw_qtx"} /></div></div>}
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        schedule: state.openScheduling.schedule,
        EncryptedCSN: state.epic.encryptCSN,
        eCheckInStatusSuccess: state.epic.eCheckInStatusSuccess,
        enableEcheckinMandatoryUpdates: state.session.serverData && state.session.serverData.enableEcheckinMandatoryUpdates ? state.session.serverData.enableEcheckinMandatoryUpdates : false,
        hasMyChart: state.domain.hm,
        scheduleVisitType: state.openScheduling && state.openScheduling.schedule && state.openScheduling.schedule.visitType.displayName,
        careGapFlowFormInputs: state.careGap.careGapFlowFormInputs,
        careGapsSessionId: state.careGap.careGapsSessionId,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getEncryptedCSN: (csnId) => {
            dispatch({ type: types.GET_EPIC_ENCRYPT_CSN, csnId });
        },
        postCareGapFlowData: (careGapData, procedureType) => dispatch({ type: types.POST_CAREGAP_FLOW_DATA, careGapData, procedureType }),
        updateCareGapFlowFormInputs: (formInputs, procedureType) => dispatch({ type: types.UPDATE_CAREGAP_FLOW_FORM_INPUTS, formInputs, procedureType }),
        clearFlowData: () => dispatch({ type: types.CLEAR_CAREGAP_DATA_AFTER_SUBMIT })
    };
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(OpenScheduleConfirmationSuccess));